import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { WorkbenchConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { CustomerAllocationWorkbenchService } from './api/customerAllocationWorkbench.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class WorkbenchApiModule {
    public static forRoot(configurationFactory: () => WorkbenchConfiguration): ModuleWithProviders<WorkbenchApiModule> {
        return {
            ngModule: WorkbenchApiModule,
            providers: [ { provide: WorkbenchConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: WorkbenchApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('WorkbenchApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
